import { Download, Eye, Layers, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { productCodeToExplorerLayerIdMappings } from "pages/geoscape-data/constants";
import { useHistory } from "react-router";
import { useIntercom } from "react-use-intercom";
import * as Routes from "routes";
import { viewDatasetInExplorer } from "../catalogue-page";

// Reverse mapping for NATIONAL X back to backend keys
const REVERSE_PRODUCT_MAPPING: Record<string, string> = {
  "NATIONAL PLANNING": "GEOSCAPE PLANNING",
  "NATIONAL PLANNING INSIGHTS": "GEOSCAPE PLANNING INSIGHTS",
  "NATIONAL BUILDINGS": "GEOSCAPE BUILDINGS",
  "NATIONAL CADASTRE": "GEOSCAPE CADASTRE",
  "NATIONAL PROPERTY": "GEOSCAPE PROPERTY",
  "NATIONAL TREES": "GEOSCAPE TREES",
  "NATIONAL ROADS": "GEOSCAPE ROADS",
  "NATIONAL AIRPORTS": "GEOSCAPE AIRPORTS",
  "NATIONAL RAIL": "GEOSCAPE RAIL",
  "NATIONAL LOCALITIES": "GEOSCAPE LOCALITIES",
  "NATIONAL LOCAL GOVERNMENT AREAS": "GEOSCAPE LOCAL GOVERNMENT AREAS",
  "NATIONAL WARDS": "GEOSCAPE WARDS",
  "NATIONAL SOLAR": "GEOSCAPE SOLAR",
  "NATIONAL SURFACE COVER": "GEOSCAPE SURFACE COVER",
  "NATIONAL GREENSPACE": "GEOSCAPE GREENSPACE",
  "NATIONAL HYDROLOGY": "GEOSCAPE HYDROLOGY",
  "NATIONAL ELECTORAL BOUNDARIES": "ELECTORAL BOUNDARIES",
  "NATIONAL POSTCODE BOUNDARIES": "POSTCODE BOUNDARIES",
};

interface CatalogueActionsCardProps {
  licenced: boolean;
  displayProduct: string;
}

export const CatalogueActionsCard = ({
  licenced,
  displayProduct,
}: CatalogueActionsCardProps) => {
  const { showNewMessage } = useIntercom();
  const history = useHistory();

  const backendProductName =
    REVERSE_PRODUCT_MAPPING[displayProduct] || displayProduct;

  const hasExplorerLayer =
    !!productCodeToExplorerLayerIdMappings.get(backendProductName);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Get this data</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {licenced ? (
          <Button asChild className="w-full">
            <a
              href={`${Routes.dataDownload}?product=${displayProduct}&licenced=${licenced}`}
            >
              <Download />
              Download Dataset
            </a>
          </Button>
        ) : (
          <Button
            className="w-full"
            onClick={() => {
              showNewMessage(
                `I'd like to talk to someone about "${displayProduct}"`,
              );
            }}
          >
            <MessageSquare />
            Chat with Our Team
          </Button>
        )}
        <Button
          variant="outline"
          className="w-full"
          disabled={!hasExplorerLayer}
          onClick={() => viewDatasetInExplorer(displayProduct, history)}
        >
          <Layers />
          Visualise Data
        </Button>
        <Button variant="outline" className="w-full" disabled>
          <Eye />
          View Sample
        </Button>
      </CardContent>
    </Card>
  );
};
